import ACTION_TYPE from "../actions/type.action";

const initialState = {
    questions: [],
    question: {},
    selectedoption: [],
    questionIndex: -1
};

const reducer = (state = initialState, action) => {
    const {
        type,
        payload
    } = action;

    switch (type) {
        case ACTION_TYPE.CREATE_QUESTION:
            return {
                ...state,
                questions: payload
            }
        case ACTION_TYPE.ADD_TEMP_QUESTION:
            return {
                ...state,
                questions: state.questions.concat(payload)
            }
        case ACTION_TYPE.FETCH_QUESTIONS:
            return {
                ...state,
                questions: payload
            }
        case ACTION_TYPE.GET_QUESTION:
            const newNextIndex = state.questionIndex < (state.questions.length - 1 )? state.questionIndex + 1 : state.questionIndex
            console.log(newNextIndex, state.questionIndex, state.questions[newNextIndex])
            return {
                ...state,
                question: { ...state.questions[newNextIndex], questionIndex: newNextIndex + 1 },
                questionIndex: newNextIndex
            }
        case ACTION_TYPE.GET_PREVIOUS_QUESTION:
            const newPreviousIndex = state.questionIndex > 0 ? state.questionIndex - 1 : state.questionIndex
            console.log(newPreviousIndex, state.questionIndex, state.questions[newPreviousIndex])
            return {
                ...state,
                question: { ...state.questions[newPreviousIndex], questionIndex: newPreviousIndex + 1 },
                questionIndex: newPreviousIndex,
            }
        case ACTION_TYPE.GET_SELECTED_QUESTION:
            return {
                ...state,
                question: { ...state.questions[payload], questionIndex: payload + 1 },
                questionIndex: payload
            }
        case ACTION_TYPE.CLEAR_QUESTION:
            return {
                ...state,
                question: {},
                selectedoption: [],
                questionIndex: -1
            }
            case ACTION_TYPE.CLEAR_QUESTION_WITH_INDEX:
                return {
                    ...state,
                    question: {},
                    selectedoption: []
                }
        case ACTION_TYPE.UPDATE_QUESTION:
            return {
                ...state,
                questions: payload
            }
        case ACTION_TYPE.REMOVE_QUESTION:
            return {
                ...state,
                questions: payload
            }
        case ACTION_TYPE.UPDATE_CORRECT_OPTION:
            return {
                ...state,
                questions: payload
            }
        case ACTION_TYPE.SELECTED_OPTION:
            return {
                ...state,
                selectedoption: payload
            }
        case ACTION_TYPE.CLEARSELECTED_OPTION:
            return {
                ...state,
                selectedoption: []
            }

        // OPTION ACTIONS
        case ACTION_TYPE.CREATE_OPTION:
            return {
                ...state,
                questions: payload
            }
        case ACTION_TYPE.UPDATE_OPTION:
            return {
                ...state,
                questions: payload
            }
        case ACTION_TYPE.REMOVE_OPTION:
            return {
                ...state,
                questions: payload
            }
        default:
            return state;
    }
};

export default reducer;